<template>
  <div class="audience-flex leaderboard-wrap" :class="type">
    <div class="leaderboard--content vertical layout">
      <div
        class="box-audience-list"
      >
        <div class="box-audience-wrapper custom-m-b-8">
          <div
            class="audience--item horizontal layout center"
            v-for="(item,index) in scores"
            :key="index"
            :class="{active: item.active, 'break-point': item.breakPoint}"
            :id="'audience-' + index"
          >
            <div
              class="audience--rank"
              :class="{'white': isTextColourLight}"
            >
              {{ item.i }}
            </div>
            <div
              class="audience-flex audience--bar"
              :class="{'dark-theme': isTextColourLight}"
              ref="audience-bar"
            >
              <!-- Color bar layer 2-->
              <div
                class="audience--bar-progress layer--2"
                :style="{'width': item.oldPercent + '%', 'background-color': item.color}"
              >
                <div
                  class="px-3 audience--bar-info horizontal layout custom-font-weight-bold layer--1"
                  :style="{'width': widthProgressBar}"
                >
                  <div class="bar--name">
                    <div class="team-name">
                      <span class="team-name__text" v-if="!item.aN">
                        {{ item.a }}
                      </span>
                      <span class="team-name__text" v-if="item.aN">
                        <span class="font-weight-initial">{{ item.aE }}</span>
                        <profanity-filter :text="item.aN" />
                      </span>
                    </div>
                    <div class="team-member" v-if="item.members">
                      <span v-for="(member, indexMember) in item.members" :key="indexMember" v-show="indexMember < 10">
                        <span class="font-weight-initial">{{ member.aE }}</span>
                        <profanity-filter :text="member.aN" />
                      </span>
                      <span v-if="item.members.length - 10 > 0"> + {{ item.members.length - 10 }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Audience info layer 3 -->
              <div class="px-3 audience--bar-info horizontal layout custom-font-weight-bold layer--3">
                <div class="bar--name">
                  <div class="team-name">
                    <span class="team-name__text" v-if="!item.aN">
                      {{ item.a }}
                    </span>
                    <span class="team-name__text" v-if="item.aN">
                      <span class="font-weight-initial">{{ item.aE }}</span>
                      <profanity-filter :text="item.aN" />
                    </span>
                  </div>
                  <div class="team-member" v-if="item.members">
                    <span v-for="(member, indexMember) in item.members" :key="indexMember" v-show="indexMember < 10">
                      <span class="font-weight-initial">{{ member.aE }}</span>
                      <profanity-filter :text="member.aN" />
                    </span>
                    <span v-if="item.members.length - 10 > 0" class="more-member">+ {{ item.members.length - 10 }}</span>
                  </div>
                </div>
              </div>
              <div
                v-if="canShowStreakBadge(item)"
                class="streak"
              >
                <div class="streak-placeholder">
                  <img
                    class="streak-badge"
                    :src="require('@/assets/images/visualize-items/strike-badge.png')"
                    alt="badge"
                    width="48"
                    height="26"
                  >
                  <span class="streak-number longest-streak" v-if="slide.finalLeaderboard">
                    {{ item.ls }} <!-- longest streak of the whole game -->
                  </span>
                  <span class="streak-number current-streak" v-if="!slide.finalLeaderboard">
                    {{ item.s }} <!-- current streak -->
                  </span>
                </div>
              </div>
            </div>
            <div class="audience--points horizontal layout end" ref="audience--points">
              <div>
                {{ item.t | formatTotalPoint }}{{ $t("pointShortcut") }}
              </div>
            </div>
          </div>
        </div>

        <div class="button-next-leaderboard" v-if="slide.finalLeaderboard">
          <a
            @click="nextQuestion"
            style="cursor: pointer"
            class="text-next-slide"
            :class="{'white': isTextColourLight}"
          >
            <ui-button block size="lg" variant="outline-dark">
              <span>{{ $t("nextButton") }}</span>
              <i
                :class="{
                  'fas fa-angle-double-right': !checkNextSlide,
                  'loading-spinner black mb--2px': checkNextSlide,
                }"
              />
            </ui-button>
          </a>
        </div>
      </div>
      <div class="audience-flex" />
    </div>
  </div>
</template>
<script>
import Util from '@/util'
import Config from '@/config'
import UiButton from '@/components/UI/Button.vue'
import ProfanityFilter from '@/components/utils/ProfanityFilter.vue'
import { mapState, mapGetters } from 'vuex'
import * as Sentry from '@sentry/vue'

const indexLimit = 30
const aboveLimit = 5
const belowLimit = 5
const hiddenLimit = 20

export default {
  components: {
    UiButton,
    ProfanityFilter,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'individual',
    },
  },
  data() {
    return {
      widthProgressBar: '0px',
      scores: [],
      indexCurrentUser: 0,
      checkNextSlide: false,
      indexScroll: 0,
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      presentation: (state) => state.presentation,
    }),
    ...mapGetters({
      slide: 'activeActivity',
    }),
    ...mapGetters('themeModule', ['isTextColourLight']),
    canShowStreakBadge() {
      return (item) => {
        if (this.presentation && !this.presentation.isEnableStreakDetection) return false

        const isThisAudience = (item.a === this.audienceId)
        const isFinalLeaderboard = this.slide.finalLeaderboard
        if (isFinalLeaderboard) {
          return isThisAudience && item.ls > 1
        }

        return isThisAudience && item.s > 0
      }
    },
  },
  created() {
    if (this.type === 'individual') {
      this._handleDataIndividual()
    } else if (this.type === 'team') {
      this._handleDataTeam()
    }
  },
  mounted() {
    let widthProgressBar = 0
    let widthAudiencePoints = 0
    if (this.$refs['audience-bar'] && this.$refs['audience-bar'].length) {
      widthProgressBar = this.$refs['audience-bar'][0].offsetWidth
      this.widthProgressBar = `${widthProgressBar}px`
    }
    if (this.$refs['audience--points'] && this.$refs['audience--points'].length) {
      widthAudiencePoints = this.$refs['audience--points'][0].offsetWidth
      this.$refs['audience--points'].forEach((item) => {
        item.style.width = `${widthAudiencePoints}px`
      })
    }

    const el = document.getElementById(`audience-${this.indexScroll}`)
    if (el && this.slide && !this.slide.finalLeaderboard) {
      el.scrollIntoView({
        behavior: 'auto',
        block: 'center',
        inline: 'center',
      })
    }
  },
  methods: {
    _handleDataTeam() {
      const data = [...this.data]
      this.indexCurrentUser = data.findIndex((item) => {
        return item.id === this.$store.state.audienceQuizTeam
      })
      if (this.indexCurrentUser !== -1) {
        data[this.indexCurrentUser].active = true
      }

      if (data.length <= (indexLimit + belowLimit + aboveLimit + hiddenLimit)) {
        this.scores = this.data
      } else {
        let a1 = []
        let a2 = []
        if (this.indexCurrentUser < 50) {
          if (this.indexCurrentUser > 30) {
            a1 = data.slice(0, this.indexCurrentUser + 1)
          } else {
            a1 = data.slice(0, indexLimit)
          }
        } else {
          a1 = data.slice(0, indexLimit)
          a2 = data.slice(this.indexCurrentUser - belowLimit, this.indexCurrentUser + 1)
        }
        const a3 = data.slice(this.indexCurrentUser + 1, this.indexCurrentUser + aboveLimit + 1)
        a1.forEach((item) => {
          const index = a2.findIndex((audience) => {
            return audience.id === item.id
          })
          if (index !== -1) {
            a2.splice(index, 1)
          }

          const index2 = a3.findIndex((audience) => {
            return audience.id === item.id
          })
          if (index2 !== -1) {
            a3.splice(index2, 1)
          }
        })
        if (a1.length &&
          this.indexCurrentUser > indexLimit + aboveLimit && this.indexCurrentUser >= 50) {
          a1[a1.length - 1].breakPoint = true
        }

        const arr = a1.concat(a2, a3)
        if (this.indexCurrentUser < data.length - belowLimit) {
          arr[arr.length - 1].breakPoint = true
        }
        this.scores = arr
      }

      this.indexScroll = this.scores.findIndex((item) => {
        return item.id === this.$store.state.audienceQuizTeam
      })
    },
    _handleDataIndividual() {
      const data = [...this.data]
      this.indexCurrentUser = this.data.findIndex((item) => {
        return item.a === this.audienceId
      })
      if (this.indexCurrentUser !== -1) {
        data[this.indexCurrentUser].active = true
      }

      if (data.length <= (indexLimit + belowLimit + aboveLimit + hiddenLimit)) {
        this.scores = this.data
      } else {
        let a1 = []
        let a2 = []
        if (this.indexCurrentUser < 50) {
          if (this.indexCurrentUser > 30) {
            a1 = data.slice(0, this.indexCurrentUser + 1)
          } else {
            a1 = data.slice(0, indexLimit)
          }
        } else {
          a1 = data.slice(0, indexLimit)
          a2 = data.slice(this.indexCurrentUser - belowLimit, this.indexCurrentUser + 1)
        }
        const a3 = data.slice(this.indexCurrentUser + 1, this.indexCurrentUser + aboveLimit + 1)
        a1.forEach((item) => {
          const index = a2.findIndex((audience) => {
            return audience.a === item.a
          })
          if (index !== -1) {
            a2.splice(index, 1)
          }

          const index2 = a3.findIndex((audience) => {
            return audience.a === item.a
          })
          if (index2 !== -1) {
            a3.splice(index2, 1)
          }
        })
        if (a1.length &&
          this.indexCurrentUser > indexLimit + aboveLimit && this.indexCurrentUser >= 50) {
          a1[a1.length - 1].breakPoint = true
        }

        const arr = a1.concat(a2, a3)
        if (this.indexCurrentUser < data.length - belowLimit) {
          arr[arr.length - 1].breakPoint = true
        }
        this.scores = arr
      }
      this.indexScroll = this.scores.findIndex((item) => {
        return item.a === this.audienceId
      })
    },
    nextQuestion() {
      this.checkNextSlide = true
      this.$http
        .get(
          Config.api.getPresentation +
            this.$store.state.presentation.uniqueAccessCode,
          {
            params: {
              audience: this.audienceId,
              continue: true,
            },
          },
        )
        .then((res) => {
          this.checkNextSlide = false
          res.body = Util.formatSlide(res.body)
          Util.mixpanelTrack(
            'Leaderboard Submit',
            'Audience Submit',
            'Audience choose Next Slide',
          )
          if (res.body.id !== this.slide.id) {
            this.$store.dispatch('setSlide', res.body)
          } else {
            this.$emit('nextToWaitingScreen')
          }
          this.slide.finalLeaderboard = false
        })
        .catch(Sentry.captureException)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.leaderboard--content {
  text-align: center;
}

.audience--item {
  padding: 0 8px;
  border-radius: 4px;

  &.active {
    background-color: $primary-color;
    color: #fff;
  }

  &.break-point {
    margin-bottom: 16px;
    position: relative;
    &::before {
      font-family: 'Font Awesome 5 Free';
      font-weight: 900;
      content: "\F141";
      position: absolute;
      bottom: -16px;
      left: 50%;
      opacity: 0.4;
      margin-left: -8px;
    }
  }
}
.audience--rank {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  background-color: rgba(49, 49, 49, 0.1);
  line-height: 30px;
  font-weight: 600;
  margin-right: 8px;
  font-size: 13px;
}

.audience--points {
  margin-left: 8px;
  font-size: 12px;
}

.audience--bar  {
  position: relative;
  text-align: left;
  background-color: rgba(49, 49, 49, 0.1);
  overflow: hidden;
  margin: 4px 0;
  border-radius: 4px;
  overflow: hidden;

  &.dark-theme {
    background-color: rgba(255, 255, 255, 0.05);
  }
}

.audience--bar-progress {
  position: absolute;
  top: 0;
  left: 0;
  color: #fff;
  overflow: hidden;
  z-index: 10;
}

.layer--3 {
  .more-member {
    margin-left: 3px;
  }
}

.audience--bar-info {
  padding: 8px;

  &.layer--3 {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
  }
}
.team-name {
  margin-bottom: 8px;
  font-size: 13px;
}
.team-member {
  font-weight: normal;
  font-size: 12px;
}
.leaderboard-wrap {
  overflow: hidden;

  &.individual {
    .team-name {
      margin-bottom: 0;
    }
  }
}

.button-next-leaderboard {
  display: none;
  padding: 16px 0;
}

.team-member span {
  margin-bottom: 3px;
  display: inline-block;
  margin-right: 6px;
}

.font-weight-initial {
  font-weight: initial; // AHA-8263 fix emoji losing color on windows
}

.streak {
  position: absolute;
  z-index: 10;
  right: 5px;
  top: 3px;
  color: #5FBF78;
  font-size: 11px;
  font-weight: 600;

  &-placeholder {
    position: relative;
  }

  &-number {
    position: absolute;
    top: 5px;
    left: 2px;
    width: 24px;
    text-align: center;
  }
}
</style>
